const KLAVIYO_PUBLIC_API_KEY = "XcXa3B";
// AU mobiles like +61412345678
const PHONE_REGEX = /^\+[1-9]\d{1,14}$/;

function sendFormToKlaviyo(listId, emailInputId, phoneInputId, successId, errorId) {
  if (!listId) return true;

  var emailEl = document.getElementById(emailInputId);
  var phoneEl = document.getElementById(phoneInputId);
  var errorEl = errorId ? document.getElementById(errorId) : null;

  if (!emailEl || !phoneEl) return true;

  var email = emailEl.value.trim();
  var phone = phoneEl.value.trim();

  var phoneIsValid = PHONE_REGEX.test(phone);
  console.log("Phone raw:", phone, "valid?", phoneIsValid);

  if (!email || !emailEl.checkValidity() || !phone || !phoneIsValid) {
    if (errorEl) errorEl.classList.remove("hidden");
    return false;
  }

  if (errorEl) errorEl.classList.add("hidden");

  var payload = {
    data: {
      type: "subscription",
      attributes: {
        custom_source: "Promo signup form",
        profile: {
          data: {
            type: "profile",
            attributes: {
              email: email,
              phone_number: phone
            }
          }
        }
      },
      relationships: {
        list: {
          data: {
            type: "list",
            id: listId
          }
        }
      }
    }
  };

  fetch(
    "https://a.klaviyo.com/client/subscriptions/?company_id=" +
      KLAVIYO_PUBLIC_API_KEY,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        revision: "2025-10-15"
      },
      body: JSON.stringify(payload),
      keepalive: true
    }
  )
    .then(res => {
      console.log("Klaviyo response:", res.status);
      return res.json().catch(() => null);
    })
    .then(body => {
      if (body) console.log("Klaviyo body:", body);
    })
    .catch(err => {
      console.error("Klaviyo error:", err);
    });

  var successEl = successId ? document.getElementById(successId) : null;
  if (successEl) successEl.classList.remove("hidden");

  return true;
}
